'use client';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from './pdp-no-equipment-selected.module.scss';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';

import {
  CatButton,
  CatIconMachineExcavator
} from 'components/blocks-components';

const PdpNoEquipmentSelected = ({
  hasEquipmentsToSelect,
  onlyRenderButton = false
}: {
  hasEquipmentsToSelect: boolean;
  onlyRenderButton?: boolean;
}) => {
  const {
    addEquipmentDrawer: { openDrawer: openAddEquipmentDrawer },
    selectEquipmentDrawer: { openDrawer: openSelectEquipmentDrawer }
  } = useMyEquipmentDrawer();

  const t = useTranslations();
  const title = hasEquipmentsToSelect
    ? 'SELECT_EQUIPMENT'
    : 'ADD_EQUIPMENT_ICON';

  const handleClick = () => {
    hasEquipmentsToSelect
      ? openSelectEquipmentDrawer()
      : openAddEquipmentDrawer();
  };

  const getMobileView = () => (
    <div
      className={cx(
        'd-md-none d-flex flex-column py-4 my-2 w-100',
        styles['equipment-widget__no-equipment-container']
      )}
      data-testid="mobile-widget-view"
    >
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex">
          <CatIconMachineExcavator size="lg" />
          <p
            className={cx(
              'm-0 ps-2',
              styles['equipment-widget__no-equipment-title']
            )}
          >
            {t(title)}
          </p>
        </div>
        <p className="cat-u-theme-typography-body m-0">
          {t('RESULTS_MEQ_ADD_EQUIP')}
        </p>
      </div>
      <CatButton variant="contrast" fullWidth size="lg" onClick={handleClick}>
        {t(title)}
      </CatButton>
    </div>
  );

  if (onlyRenderButton) {
    return (
      <CatButton variant="contrast" fullWidth size="sm" onClick={handleClick}>
        {t(title)}
      </CatButton>
    );
  }

  return <>{getMobileView()}</>;
};

export default PdpNoEquipmentSelected;
